import moment from 'moment'
import { colours } from '@qflow/theme'

type CertType = {
  expirationDate: string
}

export const hasCertExpired = (certOrTimeStamp: CertType | string) => {
  const timeStamp = certOrTimeStamp['expirationDate']
    ? certOrTimeStamp['expirationDate']
    : certOrTimeStamp

  const dateFormat = timeStamp.length === 10 ? 'DD/MM/YYYY' : moment.ISO_8601
  return moment(timeStamp, dateFormat).isBefore(moment.now())
}

export const isCertExpiringSoon = (certOrTimeStamp: CertType | string) => {
  const timeStamp = certOrTimeStamp['expirationDate']
    ? certOrTimeStamp['expirationDate']
    : certOrTimeStamp

  const dateFormat = timeStamp.length === 10 ? 'DD/MM/YYYY' : moment.ISO_8601
  return moment(timeStamp, dateFormat).isBefore(moment().add(30, 'days'))
}

const CERT_STATUS = {
  EXPIRED: { color: colours.RED, text: 'Expired' },
  EXPIRES_SOON: { color: colours.AMBER, text: 'Expires soon' },
  VALID: { color: 'default' }
}

export const getCertStatus = (cert: CertType) => {
  if (cert.expirationDate) {
    return hasCertExpired(cert.expirationDate)
      ? CERT_STATUS.EXPIRED
      : isCertExpiringSoon(cert.expirationDate)
        ? CERT_STATUS.EXPIRES_SOON
        : CERT_STATUS.VALID
  }
  return CERT_STATUS.VALID
}
